// shared-scroll.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AumyeSharedScrollService {
  private scrollSubject = new Subject<string>();

  scrollToElement(elementId: string) {
    this.scrollSubject.next(elementId);
  }

  getScrollObservable() {
    return this.scrollSubject.asObservable();
  }
}
